import { render, staticRenderFns } from "./ConfirmDeleteAddress.vue?vue&type=template&id=53d505bc"
import script from "./ConfirmDeleteAddress.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports